import { Link } from "@tanstack/react-router";
import { ArrowRight, Phone } from "lucide-react";
import { FaqDisclosure } from "./FaqDisclosure";
import { Reveal } from "./Reveal";

export const faqs = [
  {
    q: "How quickly will Bart get back to me?",
    a: "Bart personally returns calls and messages as soon as possible — usually the same day. No call centers, no junior reps, no runaround.",
  },
  {
    q: "Do you offer free quotes?",
    a: "Yes. We come out, look at the work, and give you an honest, written quote with no pressure. If the project isn't right for us, we'll tell you that too.",
  },
  {
    q: "Are you insured?",
    a: "Yes — we're fully insured. We'll happily provide documentation before any work begins.",
  },
  {
    q: "How long does a typical project take?",
    a: "Most exterior repaints take 3–7 days depending on size and prep work. Interior projects vary by scope. We give you a clear timeline up front and stick to it.",
  },
  {
    q: "What areas do you serve?",
    a: "We're based in Arlington, TX and serve homes within roughly 15 miles — including Mansfield, Grand Prairie, Kennedale, Fort Worth, Pantego, and more.",
  },
  {
    q: "What kind of paint do you use?",
    a: "We use professional-grade paints from Sherwin-Williams and Benjamin Moore. We'll recommend the right product for your surface and the Texas climate.",
  },
];

export function FAQ() {
  return (
    <section className="mx-auto max-w-7xl px-6 py-24">
      <div className="grid gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-5 lg:sticky lg:top-28 lg:self-start">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-accent">
            Frequently Asked
          </p>
          <h2 className="mt-3 font-display text-4xl text-primary md:text-5xl">
            Straight answers, no fine print.
          </h2>
          <p className="mt-5 text-muted-foreground">
            Quick answers to the questions Arlington homeowners ask most. Still wondering
            something? Just give Bart a call.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="tel:6824545997"
              className="inline-flex items-center gap-2 rounded-full bg-accent px-5 py-3 text-sm font-semibold text-accent-foreground hover:opacity-90"
            >
              <Phone className="h-4 w-4" /> 682-454-5997
            </a>
            <Link
              to="/faq"
              className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-5 py-3 text-sm font-semibold text-primary hover:border-accent/40"
            >
              See full FAQ <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-7">
          <div className="w-full space-y-3">
            {faqs.map((f) => (
              <FaqDisclosure key={f.q} question={f.q} answer={f.a} />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
